export default function c1coordinates(x, y) {
  this.c1.x = x;
  this.c1.y = y;
}
